function LoadingDice() {
  return (
    <div style={{ position: "relative", width: 60, height: 60, flexShrink: 0 }}>
      {/* Pulse ring */}
      <div
        style={{
          position: "absolute",
          inset: -8,
          borderRadius: "50%",
          border: "1.5px solid rgba(249,115,22,.4)",
          animation: "gpPulseRing 1s ease-out infinite",
        }}
      />
      <div
        style={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          background:
            "radial-gradient(circle,rgba(249,115,22,.18) 0%,rgba(249,115,22,.06) 60%,transparent 100%)",
          border: "1px solid rgba(249,115,22,.28)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 26,
          animation: "spin 1s linear infinite",
        }}
      >
        🎲
      </div>
    </div>
  );
}

export default LoadingDice;
